import Bom from "@system/config/bom";
import Auth from "@system/config/auth";
import Product from "@system/config/product";
import store from "../storeWire";
import BOMRepository from "../repository/BOMRepository";
import ProductDetailAPICall from "./ProductDetailAPICall";
import System from "../helper/system";
import Helper from "../helper/Helper";
import liveAuth from "../helper/liveAuth";
import { __remove, __set } from "../store/axios_indicator";
import { isArray } from "underscore";
import { set_product_master_data } from "src/store/slice/model/ProductListing";
import Api from "./APIHandler";
import Constants from "src/helper/Constants";

const API = new Api({});
const speedBoat = System.avUserInfoData.speedBoatAbbr;
const { storageName: { GUEST_SESSION_ID, GUEST_BOM_ID } } = System
const { systemModules: { BOM } } = Constants
class BOMAPICall {

    fetchBOMList = async (prams) => {

        let res = {};
        const param = {}
        param.data = {
            bomName: '', "top": -1, "skip": 0, speedBoat: speedBoat, source: prams.source
        }
        const url = liveAuth.check() ? Bom.BOM_LISTING : Bom.GUEST_BOM_LISTING;

        if (!liveAuth.check()) {
            param.data = { ...param.data, sessionId: localStorage.getItem(GUEST_SESSION_ID) }
        }

        await API.post(url, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data.data
            }
        });
        return res;
    }

    createBOM = async (params = false) => {
        const url = liveAuth.check() ? Bom.CREATE_BOM : Bom.Guest_CREATE_BOM;
        let res = {};
        const param = {}
        param.data = { ...params, speedBoat: speedBoat }
        if (!liveAuth.check()) {
            param.data = {
                ...param.data, sessionId: localStorage.getItem(GUEST_SESSION_ID)
            }
        } else {
            param.data = {
                ...param.data, shipToAddressId: System.getUserShippingAddress()
            }
        }

        __set('BOM_CREATE_API_CALL');
        await API.post(url, param).then((resHer) => {
            if (resHer?.data) {
                !liveAuth.check() && localStorage.setItem(GUEST_BOM_ID, resHer?.data?.data);
                res = resHer.data
            }
        }).finally(() => {
            __remove('BOM_CREATE_API_CALL');
        })
        return res;
    };

    assignBOMToProject = async (params = false) => {
        let res = {};
        const param = {}
        param.params = params
        __set('BOM_ASSIGN_TO_PROJECT_API_CALL');
        await API.put(Bom.ASSIGN_BOM_TO_PROJECT, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        });
        __remove('BOM_ASSIGN_TO_PROJECT_API_CALL');
        return res;
    };

    editBOM = async (params = false) => {
        let res = {};
        const param = {}
        param.data = params
        __set('BOM_OPERATION_API_CALL');
        await API.post(Bom.EDIT_BOM, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        }).finally(() => {
            __remove('BOM_OPERATION_API_CALL');
        });
        return res;
    };

    setBOMIsRematchFlag = async (params = false) => {
        let res = {};
        const param = {}
        param.params = params
        __set('BOM_REMATCH_FLAG_OPERATION_API_CALL');
        await API.put(Bom.BOM_SET_IS_REMATCH_FLAG_IN_BOM_DETAIL, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        });
        __remove('BOM_REMATCH_FLAG_OPERATION_API_CALL');
        return res;
    };

    addPartToBOM = async (params = false) => {
        const url = liveAuth.check() ? Bom.ADD_PART_TO_BOM : Bom.GUEST_ADD_PART_TO_BOM;
        let res = {};
        const param = {}
        param.data = { ...params, speedBoat: speedBoat }
        if (!liveAuth.check()) {
            param.data = { ...param.data, sessionId: localStorage.getItem(GUEST_SESSION_ID), bomIds: [localStorage.getItem(GUEST_BOM_ID)] }
        } else {
            param.data = { ...param.data, shipToAddressId: System.getUserShippingAddress() }
        }

        __set('BOM_ADD_TO_BOM_API_CALL');
        await API.post(url, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        }).finally(() => {
            __remove('BOM_ADD_TO_BOM_API_CALL');
        });
        return res;
    };

    getBomDetailByBomID = async (params = {}) => {
        let res = {};
        const param = {}
        param.params = params
        await API.get(Bom.BOM_DETAIL_BY_BOM_ID, param).then((resHer) => {
            if (resHer?.data?.isSuccessFull) {
                res = resHer.data.data
            } else {
                window.location.href = Bom.getBomRouteURL();
            }
        }).catch(e => {
            window.location.href = Bom.getBomRouteURL();
        });
        return res;
    };

    deleteBOMByBomID = async (params = {}) => {
        let res = {};
        const param = {}
        param.params = params
        __set('BOM_OPERATION_API_CALL');
        await API.delete(Bom.BOM_DELETE_BY_BOM_ID, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data.data
            }
        }).finally(() => {
            __remove('BOM_OPERATION_API_CALL');
        })
        return res;
    };

    copyBOMByBomID = async (params = {}) => {
        let res = {};
        const param = {}
        param.params = params
        __set('BOM_OPERATION_API_CALL');
        await API.put(Bom.BOM_COPY_BY_BOM_ID, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data.data
            }
        })
        __remove('BOM_OPERATION_API_CALL');
        return res;
    };

    getBomHealthByBomID = async (params = {}) => {
        let res = {};
        const param = {}
        param.params = params
        await API.get(Bom.BOM_HEALTH_BY_BOM_ID, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data.data
            }
        })
        return res;
    };

    getBomDetailByBomIDWithType = async (params = {}) => {
        const url = liveAuth.check() ? Bom.BOM_DETAIL_BY_BOM_ID_WITH_TYPE : Bom.GUEST_BOM_DETAIL_BY_BOM_ID_WITH_TYPE;
        let res = {};
        if (params.top === undefined) {
            params.top = 10;
        }
        params.top = parseInt(params.top);
        if (params.top > 0 && window.bom_skip_calulated !== undefined && window.bom_skip_calulated === 'yes') {
            params.skip = params.top - 10;
            window.bom_skip_calulated = 'yes';
        } else {
            const skipData = params.skip
            params.skip = params.skip === 0 ? params.skip : params.top > 20 ? params.top - 10 : 0;
            params.top = skipData === 0 ? params.top + 1 : params.top > 20 ? 10 : 20
        }
        if (!params.sortColumn) {
            params = {
                ...params,
                "sortColumn": "sequence_number",
                "sortOrder": "asc"
            };
        }

        params.isReRunPartMatch = true;

        if (!liveAuth.check()) {
            params.sessionId = localStorage.getItem(GUEST_SESSION_ID)
        }
        const param = {}
        param.data = params
        await API.post(url, param).then((resHer) => {
            if (resHer?.data?.isSuccessFull) {
                res = resHer.data.data
                if (!liveAuth.check() && !res?.totalMatches) {
                    __remove('BOM_TAB_API_CALL');
                  }
            } else {
                window.location.href = Bom.getBomRouteURL();
            }
        }).catch(e => {
            setTimeout(() => {
                window.location.href = Bom.getBomRouteURL();
            }, 2000)
        });
       return res;
    };

    downloadBomTemplate = async (params = {}) => {
        const res = {};
        const param = {}
        param.data = params
        param.data.responseType = "blob"
        await API.post(Bom.DOWNLOAD_BOM_TEMPLATE, param).then((resHer) => {
            Helper.downloadFileFromRes(resHer.data, 'bomtemplate.xlsx');
        })
        return res;
    }

    fetchProductCategoryList = async () => {
        __set('BOM_PRODUCT_CATEGORY_API_CALL');
        const res = await new ProductDetailAPICall().getProductCategory();
        __remove('BOM_PRODUCT_CATEGORY_API_CALL');
        return res;
    };

    attachBOMAlternativeToBOMDetailAPICall = async (res_data_Exact_records) => {
        const itemNumbersArray = [];
        const itemNumbersArrayResponseObject = {};
        Object.entries(res_data_Exact_records).map((v) => {
            if (v[1].bom_alternative_object === undefined && v[1].itemNumber) {
                itemNumbersArray.push(v[1].itemNumber)
            }
        });
        if (itemNumbersArray.length === 0) {
            return res_data_Exact_records;
        }
        try {
            const param = {}
            param.data = {
                speedBoat: System.avUserInfoData.speedBoatAbbr,
                itemNumbers: itemNumbersArray,
                "productResponseTypes": "CountOnly",
                "orderby": "",
                "top": 0,
                "skip": 0
            }
            await API.post(Bom.BOM_DETAIL_ALTERNATIVE_COUNT_CALL, param).then((resHer) => {
                if (resHer?.data?.Data && resHer.data.Data.length > 0) {
                    resHer.data.Data.map((v) => {
                        itemNumbersArrayResponseObject[v.ItemNumber] = v;
                    })
                }
            })
        } catch (e) {
            return res_data_Exact_records;
        }
        Object.entries(res_data_Exact_records).map((v) => {
            if (itemNumbersArrayResponseObject[v[1].itemNumber] !== undefined) {
                res_data_Exact_records[v[0]].bom_alternative_object = itemNumbersArrayResponseObject[v[1].itemNumber];
            }
        });
        return res_data_Exact_records;
    };

    createPartList = async (params = false) => {
        let res = {};
        const param = {}
        param.data = { ...params, speedBoat: speedBoat, source: BOM }
        if (!liveAuth.check()) {
            param.data = { ...param.data, sessionId: localStorage.getItem(GUEST_SESSION_ID) }
        }

        const url = liveAuth.check() ? Bom.CREATE_PART_LIST : Bom.GUEST_CREATE_PART_LIST;
        __set('BOM_OPERATION_API_CALL');
        await API.post(url, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
                !liveAuth.check() && localStorage.setItem(GUEST_BOM_ID, res?.data?.bomId);
            }
        }).finally(() => {
            __remove('BOM_OPERATION_API_CALL');
        })
        return res;
    };

    bomUploadFile = async (params) => {
        const { file, source } = params;
        let res = {};
        const url = liveAuth.check() ? Bom.BOM_UPLOAD_FILE : Bom.GUEST_BOM_UPLOAD_FILE;
        const formData = new FormData()
        formData.append("file", file)
        formData.append("source", source || 'BOM')
        if (!liveAuth.check()) {
            formData.append("Speedboat", speedBoat);
            formData.append("sessionId", localStorage.getItem(GUEST_SESSION_ID));
        }
        // System.clearAllAlert();
        const param = {}
        param.data = formData
        param.data.isMultipart = true
        await API.post(url, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
                !liveAuth.check() && res.data && localStorage.setItem(GUEST_BOM_ID, res?.data?.bomId);
            }
        }).catch((e) => {
            if (e?.response?.data?.Message) {
            }
        });

        return res;
    }

    bomUploadProgress = async (params = {}) => {
        let res = {};
        const param = {}
        param.params = params
        await API.get(Bom.BOM_UPLOAD_FILE_PROGRESS, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data.data
            }
        })
        return res;
    };

    updateQuantityByBomDetailID = async (params = {}) => {
        let res = {};
        const param = {}
        param.data = params
        await API.put(Bom.UPDATE_BOM_DETAIL_QUANTITY_BY_BOM_DETAIL_ID, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data.data
            }
        })
        return res;
    };

    updateCustomerPartNumberByBomDetailID = async (params = {}) => {
        if (params.customerPartNumber !== undefined && params.customerPartNumber === false) {
            params.customerPartNumber = '';
        }
        if (params.customerPartNumber !== undefined && params.customerPartNumber === 'false') {
            params.customerPartNumber = '';
        }
        let res = {};
        const param = {}
        param.data = params
        await API.put(Bom.UPDATE_BOM_DETAIL_CUSTOMER_PART_NUMBER_BY_BOM_DETAIL_ID, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data.data
            }
        })
        return res;
    };

    swapPartNumber = async (params = false) => {
        let res = {};
        const param = {}
        param.data = params
        param.params = {
            bomDetailId: params.bomDetailId,
            bomId: params.bomId
        }
        __set('BOM_SWAP_PART_NUMBER_API_CALL');
        await API.put(Bom.SWAP_PART_NUMBER, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        })
        __remove('BOM_SWAP_PART_NUMBER_API_CALL');
        return res;
    };

    bomDownloadFile = async (params = false) => {
        const res = {};
        const param = {}
        param.data = params
        param.data.responseType = "blob"
        __set('BOM_DOWNLOAD_API_CALL');
        await API.post(Bom.BOM_DOWNLOAD_FILE, param).then(async (resHer) => {
            if (resHer?.data) {
                Helper.downloadFileFromRes(resHer.data, 'EXPORT_BOM.' + params.fileType);
                let s = store.getState().entities.model_BOM_BOMDownloadPopup;
                s = { ...s }
                if (s.save_preference !== undefined &&
                    s.save_preference === 'yes'
                ) {
                    delete s.save_preference;
                    await new BOMRepository().saveDownloadFilePreference(s);
                }
            }
        });
        __remove('BOM_DOWNLOAD_API_CALL');
        return res;
    };

    bomEmailFile = async (params = false) => {
        let res = {};
        const param = {}
        param.data = params
        __set('BOM_EMAIL_API_CALL');
        await API.post(Bom.BOM_EMAIL_FILE, param).then(async (resHer) => {
            if (resHer?.data) {
                res = resHer.data
                let s = store.getState().entities.model_BOM_BOMDownloadPopup;
                s = { ...s };
                if (s.save_preference && s.save_preference === 'yes') {
                    delete s.save_preference;
                    await new BOMRepository().saveDownloadFilePreference(s);
                }
            }
        })
        __remove('BOM_EMAIL_API_CALL');
        return res;
    };

    saveDownloadFilePreference = async (params = {}) => {
        let res = {};
        const param = {}
        params.preferenceType = params?.prefType ? params.prefType : Constants.PreferenceType.Download_Bom_Columns;
        param.data = params
        await API.post(Auth.SAVE_USER_PREFRENCE_URL, param).then(async (resHer) => {
            res = resHer.data;
        });
        return res;
    };

    fetchDownloadFilePreference = async (params = {}) => {
        let res;
        const param = {}
        params.preferenceType = params?.prefType ? params.prefType : Constants.PreferenceType.Download_Bom_Columns;
        param.data = params
        __set('BOM_SAVE_PREFERENCE_API_CALL');
        await API.post(Bom.FETCH_DOWNLOAD_BOM_PREFERENCE, param).then(async (resHer) => {
            if (resHer.data.data) {
                res = JSON.parse(resHer.data.data);
            }
        }).catch((err) => {
            if (err.response.data.Message === "No records found.") {
                res = { selected_fields: {}, export_type: "csv" }
            }
        });
        __remove('BOM_SAVE_PREFERENCE_API_CALL');
        return res;
    };

    removePartNumber = async (params = false) => {
        let res = {};
        const param = {}
        param.params = params
        __set('BOM_OPERATION_API_CALL');
        await API.put(Bom.REMOVE_PART_NUMBER, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data;
            }
        });
        __remove('BOM_OPERATION_API_CALL');
        return res;
    };

    getMultipleMatchProductSearch = async (params = {}) => {
        let res = {};
        __set('BOM_MULTIPLE_MATCH_PRODUCT_SEARCH')
        const param = {}
        param.params = { ...params, top: 10, speedBoat: System.avUserInfoData.speedBoatAbbr }
        await API.get(Bom.BOM_MULTIPLE_MATCH_PRODUCT_SEARCH, param).then(async (resHer) => {
            if (resHer?.data) {
                res = resHer.data.Data;
                let processed_payload = {
                    value: []
                };
                let value = [];

                if (res?.Products && res?.Products?.length > 0) {
                    res.Products.map((v, i) => {
                        let here_v = {};
                        here_v = v;
                        here_v.ROHSCompliantCodeValue = here_v.ROHSCompliantCode !== undefined ? Product.product__ROHSCompliantCode(here_v.ROHSCompliantCode) : false
                        here_v.EndOfLifeFlag = here_v.EndofLifeFlag === 'Yes' || here_v.EndofLifeFlag === true || here_v.EndofLifeFlag === 'Y' ? true : false
                        here_v.NCNRFlag = here_v.NCNRFlag === 'Yes' || here_v.NCNRFlag === true || here_v.NCNRFlag === 'Y' ? true : false
                        here_v.ObsoleteFlag = here_v.ObsoleteFlag === 'Yes' || here_v.ObsoleteFlag === true || here_v.ObsoleteFlag === 'Y' ? true : false

                        value[i] = here_v;
                    })
                    processed_payload.value = value;
                }
                const res_made = {
                    value: processed_payload.value
                };

                await store.dispatch(set_product_master_data(res_made));
                if (res_made && isArray(res_made) && res_made.length > 0) {
                    res.Products = res_made;
                }
                __remove('BOM_MULTIPLE_MATCH_PRODUCT_SEARCH')
            }
        }).catch(() => {
            __remove('BOM_MULTIPLE_MATCH_PRODUCT_SEARCH')
        });
        return res;
    };

    updateDisplayOrder = async (params = {}) => {
        let res = {};
        const param = {}
        param.params = params
        await API.put(Bom.UPDATE_DISPLAY_ORDER, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data.data;
            }
        });
        return res;
    };

    mergeGuestBomItem = async (params) => {
        let res = {};
        const param = {}
        param.data = { ...params, speedBoat: speedBoat, sessionId: localStorage.getItem(GUEST_SESSION_ID) }

        await API.post(Bom.CREATE_BOM, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        });
        return res;
    };

    fetchStaticColumns = async () => {
        let res = {};
        let url = Bom.GUEST_BOM_REMATCH_STATIC_COLUMN;
        if (liveAuth.check()) {
            url = Bom.BOM_REMATCH_STATIC_COLUMN
        }
        await API.get(url, {}).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        });
        return res;
    };

    fetchSavedColumnsPreferenceByBomID = async (params) => {
        let res = {};
        const param = {}
        param.params = params
        await API.get(Bom.BOM_SAVED_REMATCH_COLUMN_PREFERENCE, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data.data
            }
        }).catch(e => {
            window.location.href = Bom.getBomRouteURL();
        });
        return res;
    };

    fetchSavedColumnsDataByBomID = async (params) => {
        let res = {};
        const param = {}
        param.params = params
        await API.get(Bom.BOM_REMATCH_COLUMN_DATA, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data.data
            }
        }).catch(e => {
            window.location.href = Bom.getBomRouteURL();
        });
        return res;
    };

    saveColumnsPreferenceByBomID = async (params) => {
        let res = {};
        const param = {}
        param.data = params

        let url = Bom.GUEST_BOM_SAVE_REMATCH_COLUMN_PREFERENCE;
        if (liveAuth.check()) {
            url = Bom.BOM_SAVE_REMATCH_COLUMN_PREFERENCE
        }
        __set('BOM_REMATCH_OPERATION_API_CALL');
        await API.post(url, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data.data
            }
        });
        __remove('BOM_REMATCH_OPERATION_API_CALL');
        return res;
    };

    UsersWithAbandonedBomFor72Hours = async (params) => {
        let res = {};
        const param = {}
        param.data = params

        await API.put(Bom.UPDATE_BOM_PARTS, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data.data
            }
        });
        return res;
    };

    deleteProject = async (params = false) => {
        let res = {};
        const param = {}
        param.params = params
        await API.delete(Bom.DELETE_PROJECT, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        });
        return res;
    };

    editProject = async (params) => {
        let res = {};
        const param = {}
        param.data = params
        __set('BOM_PROJECT_OPERATION_API_CALL');
        await API.post(Bom.EDIT_PROJECT, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        }).catch((err) => {
            if (err?.response?.data) {
                res = err.response.data;
            }
        });;
        __remove('BOM_PROJECT_OPERATION_API_CALL');
        return res;
    };

    createProject = async (params) => {
        let res = {};
        const param = {}
        param.data = params
        __set('BOM_PROJECT_OPERATION_API_CALL');
        await API.post(Bom.CREATE_PROJECT, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        }).catch((err) => {
            if (err?.response?.data) {
                res = err.response.data;
            }
        }).finally(() => {
            __remove('BOM_PROJECT_OPERATION_API_CALL');
        });
        return res;
    };

    listProjectDetailWithBOM = async (params = false) => {
        let data_to_send = {
            total_bom: 0,
            your_bom_listing: {},
            your_bom_listing_with_project: {},
            project_listing: {},
            bom_listing_with_project: {},
        };

        let res = {};
        const param = {}
        param.params = { ...params, speedBoat: speedBoat, source: BOM }
        let url = Bom.GUEST_LIST_PROJECT_DETAIL_WITH_BOM;

        if (!liveAuth.check()) {
            param.params = { ...param.params, sessionId: localStorage.getItem(GUEST_SESSION_ID) }
        }
        else {
            url = Bom.LIST_PROJECT_DETAIL_WITH_BOM;
        }
        await API.get(url, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data.data
            }
        });
        if (res.yourBomList !== undefined && res.yourBomList.length > 0) {
            res.yourBomList.map((v) => {
                v['isDownloadLoad'] = false;
                data_to_send.your_bom_listing[v.bomId] = v;
            })
        }
        if (res.totalBoms) {
            data_to_send.total_bom = res.totalBoms;
        }
        if (res.projectList !== undefined && res.projectList.length > 0) {
            res.projectList.map((v) => {
                let bom_listing = {};
                if (isArray(v.bomList)) {
                    v.bomList.map((b_v) => {
                        b_v['isDownloadLoad'] = false; // all project list
                        bom_listing[b_v.bomId] = b_v;
                    })
                }
                data_to_send.project_listing[v.projectId] = { ...v, bom_listing };
            })
        }
        return data_to_send;
    };

    listProject = async (params = false) => {
        let res = {};
        const param = {}
        param.params = params
        await API.get(Bom.LIST_PROJECT, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        });
        return res;
    };

    getNewarkBomList = async (params) => {
        let res = {};
       
        const param = {}
        param.params = {"top": 20, "skip": 0, bomId: params}
        await API.get(Bom.BOM_Newark_LIST, param).then((resHer) => {
            if (resHer.data.isSuccessFull) {
                res = resHer.data;
            }else{
                __remove('BOM_NEWARK_LIST_API_CALL');
            }
        });
        return res; 
    };

}

export default BOMAPICall;